import { render, staticRenderFns } from "./product-location-dialog.vue?vue&type=template&id=02b5fbfa&scoped=true&"
import script from "./product-location-dialog.vue?vue&type=script&lang=js&"
export * from "./product-location-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5fbfa",
  null
  
)

export default component.exports